import { create } from 'zustand';
import { IToastStore, TToast } from './types';

const TOAST_TIMEOUT = 5000;
const TOAST_HIDE_ANIMATION = 500;

export const useToastStore = create<IToastStore>((set, get) => {
  const hideToast = (toastId: string) => {
    set(({ toasts }) => ({
      toasts: toasts.map((t) => (t?.id !== toastId ? t : { ...t, body: null })),
    }));
    setTimeout(() => {
      set(({ toasts }) => ({
        toasts: toasts.filter((t) => t?.id !== toastId),
      }));
    }, TOAST_HIDE_ANIMATION);
  };

  return {
    toasts: [],
    setToast: (body, options) =>
      set(({ toasts }) => {
        const toastId = options?.id ?? String(Date.now());
        const replaced = toasts.find((t) => t.id === toastId);
        clearTimeout(replaced?.timeout);
        const toast: TToast = {
          id: toastId,
          body,
          timeout: options?.persistent
            ? undefined
            : setTimeout(() => hideToast(toastId), TOAST_TIMEOUT),
        };
        return {
          toasts: [...toasts.filter((t) => t.id !== toastId), toast],
        };
      }),
    removeToast: (toastId) => {
      const toast = get().toasts.find((t) => t.id === toastId);
      if (!toast?.body) return;
      clearTimeout(toast.timeout);
      hideToast(toastId);
    },
    clearToasts: () =>
      set(({ toasts }) => {
        setTimeout(() => {
          set(() => ({ toasts: [] }));
        }, TOAST_HIDE_ANIMATION);
        return {
          toasts: toasts.map((t) => ({ ...t, body: null })),
        };
      }),
  };
});
